function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === 'object' && value !== null
}

/**
 * Picks a human-readable message from an API error body. Super error bodies
 * can carry objects (e.g. `{ error: 'Access denied', data: {} }`), which would
 * crash React if rendered, so only non-empty strings are returned.
 */
export function getApiErrorMessage(body: unknown, fallback: string): string {
	const candidates = isRecord(body) ? [body.data, body.error, body.message] : [body]
	const message = candidates.find((candidate): candidate is string => typeof candidate === 'string' && candidate.trim() !== '')
	return message ?? fallback
}
